import React, { createContext, useState, useContext } from 'react';

const AdvancesContext = createContext();

export const AdvancesProvider = ({ children }) => {
    const [advances, setAdvances] = useState([]);
    const [advancesvendor, setAdvancesvendor] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmittedVendor, setIsSubmittedVendor] = useState(false);
    const [positiveMissingCustomers, setPositiveMissingCustomers] = useState([]);


    return (
        <AdvancesContext.Provider value={{
            advances,
            setAdvances,
            advancesvendor,
            setAdvancesvendor,
            isSubmitted,
            setIsSubmitted,
            isSubmittedVendor,
            setIsSubmittedVendor,
            positiveMissingCustomers,
            setPositiveMissingCustomers
        }}>
            {children}
        </AdvancesContext.Provider>
    );
};
export const useAdvances = () => useContext(AdvancesContext);
